'use client'

import { ShoppingCart } from 'lucide-react'
import { useCart } from '@/lib/cart'

export function CartButton() {
  const { itemCount, openDrawer } = useCart()

  return (
    <button
      onClick={openDrawer}
      className="relative text-[var(--color-text-muted)] hover:text-[var(--color-text-primary)] transition-colors"
      aria-label={`Cart (${itemCount} items)`}
    >
      <ShoppingCart size={20} />
      {itemCount > 0 && (
        <span className="absolute -top-1.5 -right-1.5 bg-[var(--color-cta)] text-[var(--color-cta-text)] text-[10px] font-medium w-4.5 h-4.5 min-w-[18px] min-h-[18px] rounded-full flex items-center justify-center leading-none">
          {itemCount > 99 ? '99+' : itemCount}
        </span>
      )}
    </button>
  )
}
